import { BacklogConfigurationService, IBacklogLevelConfiguration } from "Presentation/Scripts/TFS/FeatureRef/BacklogConfiguration/Service";
import * as WITResources from "WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking";
import * as Utils_String from "VSS/Utils/String";



// Temporary hosting enums here to avoid taking dependency on Analytics code outside of Backlogs grid
// TODO: remove when completing #1610969
export enum RollupType {
    Progress,
    Total
}

export enum RollupAggregation {
    Count = 1,
    Sum = 2
}

export interface RollupCalculationSettings {
    workItemTypeFilter?: string;
    backlogFilter?: string;
    type: RollupType;
    aggregation: RollupAggregation;
    aggregationField?: string;
}

export function getRollupColumnReferenceName(rollupMetric: RollupCalculationSettings, isCustom?: boolean): string {
    let referenceName = "System.Backlog.Rollup.";
    if (isCustom) {
        referenceName += "Custom.";
    }
    switch (rollupMetric.type) {
        case RollupType.Progress:
            referenceName += "ProgressBy.";
            break;
        case RollupType.Total:
            referenceName += "Total.";
    }

    if (rollupMetric.aggregation === RollupAggregation.Sum) {
        if (rollupMetric.aggregationField) {
            referenceName += rollupMetric.aggregationField + ".";
        }
    }

    if (rollupMetric.workItemTypeFilter) {
        referenceName += rollupMetric.workItemTypeFilter.replace(/\s/g, "");
    } else if (rollupMetric.backlogFilter) {
        referenceName += rollupMetric.backlogFilter.replace(/\s/g, "");
    } else {
        referenceName += "AllCompletedDescendants";
    }

    return referenceName;
}

export function getRollupColumnDisplayName(rollupMetric: RollupCalculationSettings, friendlyNames?: { backlogName?: string; fieldName?: string }) {
    if (rollupMetric.type === RollupType.Progress) {
        if (rollupMetric.workItemTypeFilter) {
            if (rollupMetric.aggregation === RollupAggregation.Sum) {
                return Utils_String.format(
                    WITResources.RollupColumn_ProgressBy_Filter_Field,
                    rollupMetric.workItemTypeFilter,
                    friendlyNames && friendlyNames.fieldName
                );
            }
            return Utils_String.format(WITResources.RollupColumn_ProgressBy_WorkItemType, rollupMetric.workItemTypeFilter);
        }

        if (rollupMetric.backlogFilter) {
            if (rollupMetric.aggregation === RollupAggregation.Sum) {
                return Utils_String.format(
                    WITResources.RollupColumn_ProgressBy_Filter_Field,
                    friendlyNames && friendlyNames.backlogName,
                    friendlyNames && friendlyNames.fieldName
                );
            }
            return Utils_String.format(WITResources.RollupColumn_ProgressBy_Backlog, friendlyNames && friendlyNames.backlogName);
        }

        if (rollupMetric.aggregation === RollupAggregation.Sum) {
            return Utils_String.format(WITResources.RollupColumn_ProgressBy_EffortField, friendlyNames && friendlyNames.fieldName);
        }

        return WITResources.RollupColumn_ProgressBy_AllCompletedDescendants;
    }

    if (rollupMetric.workItemTypeFilter) {
        if (rollupMetric.aggregation === RollupAggregation.Sum) {
            return Utils_String.format(
                WITResources.RollupColumn_TotalBy_Filter_Field,
                rollupMetric.workItemTypeFilter,
                friendlyNames && friendlyNames.fieldName
            );
        }
        return Utils_String.format(WITResources.RollupColumn_TotalBy_WorkItemType, rollupMetric.workItemTypeFilter);
    }

    if (rollupMetric.backlogFilter) {
        if (rollupMetric.aggregation === RollupAggregation.Sum) {
            return Utils_String.format(
                WITResources.RollupColumn_TotalBy_Filter_Field,
                friendlyNames && friendlyNames.backlogName,
                friendlyNames && friendlyNames.fieldName
            );
        }
        return Utils_String.format(WITResources.RollupColumn_TotalBy_Backlog, friendlyNames && friendlyNames.backlogName);
    }

    if (rollupMetric.aggregation === RollupAggregation.Sum) {
        return Utils_String.format(WITResources.RollupColumn_TotalBy_FieldName, friendlyNames && friendlyNames.backlogName);
    }

    return WITResources.RollupColumn_TotalBy_AllDescendants;
}

export function getBacklogFilterNameById(backlogFilterId: string): string {
    try {
        return getBacklogFilterById(backlogFilterId).name;
    } catch {
        return "";
    }
}

export function getBacklogWorkItemTypesById(backlogFilterId: string): string[] {
    try {
        return getBacklogFilterById(backlogFilterId).workItemTypes;
    } catch {
        return [];
    }
}

export function getBacklogFilterById(backlogFilterId: string): IBacklogLevelConfiguration | null {
    const matchingBacklogs = BacklogConfigurationService.getBacklogConfiguration()
        .getAllBacklogLevels()
        .filter(backlogLevel => {
            return backlogLevel.id === backlogFilterId;
        });
    return matchingBacklogs[0];
}
